export default __webpack_public_path__ + "static/novo-logo-web-c0cb1ff384397e775b01b38d9922976a.png";